<div class="event-detail" [ngSwitch]="detailStrategy">

    <!-- Field-level diff table -->
    <table *ngSwitchCase="'field-diff'" class="diff-table">
        <thead>
            <tr><th>Field</th><th>Before</th><th>After</th></tr>
        </thead>
        <tbody>
            <tr *ngFor="let f of changedFields">
                <td>{{ f.field }}</td>
                <td class="old-value">{{ f.oldVal }}</td>
                <td class="new-value">{{ f.newVal }}</td>
            </tr>
        </tbody>
    </table>

    <!-- Order created / copied — key-value card -->
    <div *ngSwitchCase="'order-created'" class="kv-card">
        <div *ngFor="let e of newValueEntries" class="kv-row">
            <span class="kv-label">{{ e.field }}</span>
            <span class="kv-value">{{ e.value }}</span>
        </div>
    </div>

    <!-- Order deleted — final state card -->
    <div *ngSwitchCase="'order-deleted'" class="kv-card">
        <div *ngFor="let e of oldValueEntries" class="kv-row">
            <span class="kv-label">{{ e.field }}</span>
            <span class="kv-value">{{ e.value }}</span>
        </div>
    </div>

    <!-- Item added — table format -->
    <table *ngSwitchCase="'item-card'" class="diff-table">
        <thead>
            <tr><th>Field</th><th>Value</th></tr>
        </thead>
        <tbody>
            <tr *ngFor="let e of newValueEntries">
                <td>{{ e.field }}</td>
                <td>{{ e.value }}</td>
            </tr>
        </tbody>
    </table>

    <!-- Item updated — diff table -->
    <table *ngSwitchCase="'item-diff'" class="diff-table">
        <thead>
            <tr><th>Field</th><th>Before</th><th>After</th></tr>
        </thead>
        <tbody>
            <tr *ngFor="let f of changedFields">
                <td>{{ f.field }}</td>
                <td class="old-value">{{ f.oldVal }}</td>
                <td class="new-value">{{ f.newVal }}</td>
            </tr>
        </tbody>
    </table>

    <!-- Item deleted — final state card -->
    <div *ngSwitchCase="'item-deleted'" class="kv-card">
        <div *ngFor="let e of oldValueEntries" class="kv-row">
            <span class="kv-label">{{ e.field }}</span>
            <span class="kv-value">{{ e.value }}</span>
        </div>
    </div>

    <!-- Note added — quoted text -->
    <div *ngSwitchCase="'note-added'" class="note-block">
        <blockquote>{{ event.newValue?.noteText }}</blockquote>
    </div>

    <!-- Note updated — before/after text -->
    <div *ngSwitchCase="'note-diff'" class="note-diff">
        <div class="note-before">
            <span class="note-label">Before:</span>
            <blockquote>{{ event.oldValue?.noteText }}</blockquote>
        </div>
        <div class="note-after">
            <span class="note-label">After:</span>
            <blockquote>{{ event.newValue?.noteText }}</blockquote>
        </div>
    </div>

    <!-- SAP error card -->
    <div *ngSwitchCase="'sap-error'" class="error-card">
        <mat-icon>error</mat-icon>
        <div class="error-details">
            <div *ngIf="event.newValue?.errorCode" class="error-code">{{ event.newValue.errorCode }}</div>
            <div class="error-message">{{ event.newValue?.errorMessage }}</div>
        </div>
    </div>

</div>
